import { Cols } from "../shared/Consts";
import usePortfolio from "../hooks/PortfolioProvider";
import { usePath } from "../libs/path/PathProvider";
import Utils from "../portlibs/PortUtils";
import Portfolio from "../models/Portfolio";
import PortUtils from "../portlibs/PortUtils";
import HoldingTable from "../components/HoldingTable";
import useDateRangeFilter from "../portlibs/DateRangeFilterProvider";

const COLS = [Cols.name, Cols.quantity, Cols.averagePrice, Cols.originalCost, Cols.holdingCost, Cols.currentPrice, Cols.holdingValue, Cols.dividend, Cols.profit, Cols.gain, Cols.mwPercent];
const COLS_FILTERED = [Cols.name, Cols.quantity, Cols.averagePrice, Cols.holdingCost, Cols.currentPrice, Cols.holdingValue, Cols.dividend, Cols.profit, Cols.gain, Cols.holdingPercent];
export default function SummaryPage(){
    const {query} = usePath()
    const {account,currency,filter,showDisposed} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()
    const {end} = useDateRangeFilter()
    const cols = account<0 ? COLS : COLS_FILTERED

    let rows = portfolio.filter(currency, filter, account, true)
    if (!showDisposed) rows = rows.filter(row => !Utils.isZero(row.quantity))
    if (!PortUtils.dateEq(end.toDate(), new Date())) {
        rows = PortUtils.trimHoldings(rows, end.toDate().getTime())
    }
    const footer = Portfolio.buildTotal(currency, rows, account>=0 || filter ? 0 : portfolio.getDeposits(account, currency))
    return <HoldingTable tableName="home" cols={cols} rows={rows} footer={footer}/>
}